import { gql } from '@apollo/client';

export const getPartidosSuc = gql`
query partidoSucApi{
    partidosSuc(idProvincia:$idProvincia)  
    @rest(type: "Partido", path: "/gateway/sucursales/location/region/{args.idProvincia}"){
        id_partido
        desc_partido
    }
}
`   